import { getOntologyServiceBaseUrl } from '../../config'
import { createOntologyHeaders } from '../core'

const ONTOLOGY_SERVICE_URL = getOntologyServiceBaseUrl()

/** Fetch an authenticated tabular page-image URL returned by the job detail route. */
export async function fetchTabularPageImage(imageUrl: string): Promise<Blob> {
  const path = imageUrl.replace(/^\/api\/ontology/, '')
  const headers = createOntologyHeaders()
  headers.delete('Content-Type')
  const response = await fetch(`${ONTOLOGY_SERVICE_URL}${path}`, { headers })
  if (!response.ok) {
    throw new Error(`page image fetch failed (${response.status})`)
  }
  return response.blob()
}
